"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_PRODUCT_IN_LIST = void 0;
const MAX_PRODUCT_IN_LIST = exports.MAX_PRODUCT_IN_LIST = 100;
//# sourceMappingURL=app.js.map